<!-- Desktop: stack toasts top-right, Mobile: bottom-center -->
<div
  class="toast-stack"
  [class.mobile]="isMobile()"
>
  @for (toast of toasts(); track toast.id) {
    <div
      class="toast"
      animate.leave="removing"
      [class.toast-success]="toast.type === 'success'"
      [class.toast-error]="toast.type === 'error'"
      [class.toast-info]="toast.type === 'info'"
      [class.toast-warning]="toast.type === 'warning'"
    >
      <div class="toast-content">
        @if (toast.title) {
          <div class="toast-title">{{ toast.title }}</div>
        }
        <div class="toast-message">{{ toast.message }}</div>
      </div>
      @if (toast.showClose ?? true) {
        <button class="toast-close" (click)="dismiss(toast.id)">
          &times;
        </button>
      }
      @if (toast.duration && toast.duration > 0) {
        <div class="absolute bottom-0 left-0 right-0 h-[3px] bg-border rounded-b-xl overflow-hidden">
          <div class="h-full bg-current origin-left toast-progress-bar" [style.animationDuration.ms]="toast.duration"></div>
        </div>
      }
    </div>
  }
</div>